import { setBaseUrl, useApiQuery } from 'theSource/utils';
import { ConfigurationResponseDto } from './types';
import { CONFIGURATION_ENDPOINT, GET_CONFIGURATION_QUERY_KEY } from './utils';

export const useConfigurationQuery = () => {
  const { data: configuration, isLoading: isLoadingConfiguration } =
    useApiQuery<ConfigurationResponseDto, unknown>({
      queryKey: GET_CONFIGURATION_QUERY_KEY,
      endpoint: CONFIGURATION_ENDPOINT,
      config: { baseURL: '/' },
      onSuccess: (response) => setBaseUrl(response.apiHost),
      snackbarOptions: { position: 'bottom' },
    });

  return { configuration, isLoadingConfiguration };
};
